module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-18.a38d4e75.jpg";